var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 mb-2"},[_c('div',{staticClass:"card text-center"},[_c('div',{staticClass:"card-header",on:{"click":function($event){_vm.fetchData()}}},[_vm._v(_vm._s(_vm.home.label))]),_vm._v(" "),_c('div',{staticClass:"card-body text-white bg-danger"},[_c('h1',[_vm._v(_vm._s(_vm.count))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5113d20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/CountCard.vue
// module id = null
// module chunks = 